import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';
import { cartDisplayCount } from '@theme/cart-count';

/**
 * Header actions component that manages cart notifications.
 *
 * @typedef {object} Refs
 * @property {HTMLElement} liveRegion - The live region for cart announcements.
 *
 * @extends {Component<Refs>}
 */
class HeaderActions extends Component {
  requiredRefs = ['liveRegion'];

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, this.#onCartUpdate);
  }

  /**
   * Handles cart update events and announces the new count to screen readers.
   *
   * Announces what the bubble shows, which is not `item_count`: a bundle is
   * several cart lines but one item. See cart-count.js.
   * @param {CustomEvent<{ resource?: { item_count?: number, items?: [] } }>} event
   */
  #onCartUpdate = (event) => {
    const cart = event.detail.resource;
    if (cart?.item_count === undefined) return;
    const cartCount = cartDisplayCount(cart);

    this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
  };
}

if (!customElements.get('header-actions')) {
  customElements.define('header-actions', HeaderActions);
}
